import { builderFragment } from './fragments.gql'

export default slug => `query {
  collection(filter: {slug: {eq: "${slug}"}}) {
    slug
    ${builderFragment}
  }
}`
